module.exports = __webpack_public_path__ + "static/media/news.ebf02e88.jpg";